/* eslint-disable camelcase */
import _ from 'lodash';
import Service from './abstract';
import { types } from '../constants/files';
const BUCKET = process.env.REACT_APP_PUBLIC_S3_BUCKET || 'staticfintech03';
// import usersService from './users';

// const defaultPlatform = 5;
// const withPerson = `${withPersonSmall},${withDevices},${withPersonTelephones},${withPersonDocuments},${withPersonEmail}`;
const withPerson = 'storeFiles,storeAddresses,storeRequests,files';
const withFiles = withPerson + ',addresses,files,requests';
const withPersonSeller = 'users,users.person,users.person.attributes,users.person.attributes.attribute,users.person.documents,users.roles,users.roles.role,users.status';
const defaultCommerce = {
    order: 'created_at-DESC',
    pageSize: 100
};
const withStore = 'store,loan_request,sign_request,store.store_status,sign_request.person,sign_request.person.documents,loan_request.loan_request_external_person';

const defaultOneCommerce = {
    with: withFiles,
};

const defaultSellers = {
    with: withPersonSeller,
};

const defaultLoansList = {
    with: withStore
};

class CuotitasStore extends Service {
    constructor () {
        super('cuotitasstores');
        // this.basePathLocal = 'http://localhost:64055';
    };

    //
    // Stores
    //
    health () {
        return this.get({
            url: `${this.basePath}/health`,
        });
    };

    find (data) {
        const options = {
            url: `${this.basePath}/stores`,
            qs: _.defaultsDeep({}, data, defaultCommerce),
        };

        return super.find(options);
    };

    getStores () {
        return this.get({
            url: `${this.basePath}/stores`
        }).then(requests => {
            return this.normalizeAll(requests);
        });
    }

    getLoans (options) {
        return this.get({
            url: `${this.basePath}/stores/cuotitasrequests`,
            qs: _.defaultsDeep({}, options, defaultLoansList)
        }).then(requests => {
            return this.normalizeAll(requests);
        });
    }

    getById (id, data) {
        return this.get({
            url: `${this.basePath}/stores/${id}`,
            qs: _.defaultsDeep({}, data, defaultOneCommerce),
        });
    };

    update (id, data) {
        return this.put({
            url: `${this.basePath}/stores/${id}/status`,
            data
        });
    }

    createMultipart (data) {
        return this.post({
            url: `${this.basePath}/stores`,
            data
        });
    }

    updateStore (data, id) {
        return this.put({
            url: `${this.basePath}/stores/${id}`,
            data
        });
    }

    // Legacy version //TODO remove in the early future
    registerSeller (data) {
        return this.post({
            url: `${this.basePath}/register`,
            data
        });
    }

    register (data) {
        return this.post({
            url: `${this.basePath}/register/username`,
            data
        });
    }

    getStoreSellersList (options, id) {
        return this.get({
            url: `${this.basePath}/stores/${id}`,
            qs: _.defaultsDeep({}, options, defaultSellers)
        }).then(users => {
            return this.normalizeAll(users);
        });
    }

    //
    // Passwords
    //
    findPassword (data = {}) {
        const opts = {
            url: `${this.basePath}/passwords`,
            qs: _.defaultsDeep({}, data, ''),
        };

        return this.get(opts);
    };

    createPassword (data = {}) {
        return this.post({
            url: `${this.basePath}/passwords`,
            data
        });
    };

    updatePassword (data, id) {
        return this.put({
            url: `${this.basePath}/passwords`,
            data
        });
    };

    deletePassword (data, id) {
        return this.delete({
            url: `${this.basePath}/passwords/${id}`,
            data
        });
    };

    getUserAccount (data = {}) {
        const opts = {
            url: `${this.basePath}/loanusers/listloanusers`,
            qs: _.defaultsDeep({}, data, ''),
        };

        return this.get(opts);
    };

    createAndUpdateAccount (data, id) {
        return this.post({
            url: `${this.basePath}/users/createloanpass`,
            data
        });
    }

    async uploadS3 (data) {
        const fileBlob = data.fileUri;

        const params = new URLSearchParams({
            idType: types.document.toString(),
            bucket: BUCKET,
            dirname: data.dirname,
            filename: data.filename,
        });

        const { url, fields, id_file } = await this.get(
            `${this.basePath}/files/presigned?${params.toString()}`
        );
        const idFile = id_file;
        const signature = fields['X-Amz-Signature'];

        await this.put({
            url: `${this.basePath}/files/presigned/${idFile}`,
            data: {
                signature: signature
            }
        });

        const formData = new FormData();

        Object.keys(fields).forEach((key) => {
            formData.append(key, fields[key]);
        });

        formData.append('file', fileBlob);

        await fetch(url, {
            method: 'POST',
            body: formData
        });

        return { url: `${url}/${data.dirname}/${data.filename}`, idFile };
    }
}

export default new CuotitasStore();
